import { useTranslation } from 'react-i18next'

import { Typography } from '@/components/ui/typography'
import { formatParkingSpots } from '@/pages/parking-management/residents-parking/parking-modals'

import * as S from './general-information.styled'

type ParkingSpotFieldRowProps = {
  parkingSpots: string[] | undefined
}

// Read-only: spots are assigned in Parking Management, this row only mirrors that assignment.
export const ParkingSpotFieldRow = ({ parkingSpots }: ParkingSpotFieldRowProps) => {
  const { t } = useTranslation(['clients'])
  const value = formatParkingSpots(parkingSpots)

  return (
    <S.FieldRow>
      <S.LabelWrapper>
        <Typography size="text-medium" color="primary500" as="span" whiteSpace="nowrap">
          {t('clients:generalInformation.parkingSpot.label')}
        </Typography>
      </S.LabelWrapper>
      <S.FieldValue $isViewOnly>{value}</S.FieldValue>
    </S.FieldRow>
  )
}
